module.exports = __webpack_public_path__ + "static/img/avatar-13.e7b2c8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/profiles/avatar-13.jpg
// module id = ixg2
// module chunks = 22